import type { Priority } from '../lib/types'
import { PRIORITY_CLASSES, PRIORITY_LABEL, categoryLabel } from '../lib/format'

export function PriorityBadge({ priority }: { priority: Priority }) {
  return (
    <span
      className={`inline-flex items-center rounded-full border px-2 py-0.5 text-xs font-semibold uppercase tracking-wide ${PRIORITY_CLASSES[priority]}`}
    >
      {PRIORITY_LABEL[priority]}
    </span>
  )
}

export function CategoryBadge({ category }: { category: string }) {
  return (
    <span className="inline-flex items-center rounded-full border border-slate-200 bg-slate-50 px-2 py-0.5 text-xs font-medium text-slate-600">
      {categoryLabel(category)}
    </span>
  )
}
